module.exports = __webpack_public_path__ + "assets/images/03_active_4a4932fc9e2e1073433914d7aeb70d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03_active.png
// module id = 168
// module chunks = 0